export const Button = ({
  title, action, className, variant = "primary", size, icon, disabled = false, type = "button",
}: {
  title: string;
  action: (val?: any) => void;
  className?: string;
  variant?: "primary" | "danger" | "outline" | "success" | "clip";
  size: "xs" | "sm" | "md" | "lg";
  icon?: any;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
}) => {
  const sizeClass = {
    xs: "h-8 text-xs px-3",
    sm: "h-10 text-sm px-4",
    md: "h-11 text-sm px-5",
    lg: "h-12 text-sm px-6",
  }[size];

  const variantClass = {
    primary: "bg-primary-900 text-white hover:bg-primary-800 shadow-sm",
    outline: "bg-white border-2 border-slate-200 text-slate-700 hover:border-primary-400 hover:text-primary-900",
    danger: "bg-danger text-white hover:bg-red-700",
    success: "bg-success text-white hover:bg-green-700",
    clip: "border-2 border-primary-700 font-semibold bg-gradient-to-r from-primary-700 to-primary-500 bg-clip-text text-transparent",
  }[variant];

  return (
    <button
      type={type}
      onClick={() => action()}
      disabled={disabled}
      className={`
        ${className ?? ""} ${sizeClass} ${variantClass}
        font-body font-semibold rounded-xl
        flex items-center justify-center gap-2
        transition-all duration-200
        disabled:opacity-40 disabled:cursor-not-allowed
        hover:shadow-card-hover
      `}
    >
      {icon && icon}
      {title}
    </button>
  );
};
